import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { GeneralService } from '../services/general.service';

@Component({
  selector: 'app-index',
  templateUrl: './index.component.html',
  styleUrls: ['./index.component.scss']
})
export class IndexComponent implements OnInit {

  constructor(private router:Router, private generalService : GeneralService) { }

  ngOnInit() 
  {
    if(this.generalService.userConnecter == "")
    {
      this.router.navigate([""]);
    }
  }


}
